

  import { Component, Vue } from 'vue-property-decorator'
  import axios from 'axios';
  import { GF } from '../helpers/gf';

  import WrsLabel from './wrsControls/WrsLabel.vue';
  import WrsAlert from './wrsControls/WrsAlert.vue';
  import WrsSecurityDialog from './wrsControls/WrsSecurityDialog.vue';
  import WrsWizardStepHeader from './wrsControls/WrsWizardStepHeader.vue';
  import WrsWizardStepButtons from './wrsControls/WrsWizardStepButtons.vue';
  import WrsSearchButtons from './wrsControls/WrsSearchButtons.vue';

  import WrsViSelect from './wrsControls/viControls/WrsViSelect.vue';
  import WrsViText from './wrsControls/viControls/WrsViText.vue';

  import { IS_PRODUCTION_ENVIRONMENT, IS_VUEJS_ENVIRONMENT } from '../../olsStateManagement/helpers/constants';
  import { userService } from '../../olsStateManagement/services/devAuth.service';
  import AuthService from '../../olsStateManagement/services/auth.service';
  import {DEFAULT_ROOT_URL} from '../../olsStateManagement/helpers/constants'

  const authService = new AuthService();

  @Component({
    components: {
      'wrs-alert': WrsAlert,
      'wrs-security-dialog': WrsSecurityDialog,
      'wrs-wizard-step-header': WrsWizardStepHeader,
      'wrs-wizard-step-buttons': WrsWizardStepButtons,
      'wrs-search-buttons': WrsSearchButtons,
      'wrs-vi-select': WrsViSelect,
      'wrs-vi-text': WrsViText,
      'wrs-label': WrsLabel,
    },
  })

  export default class App extends Vue {
    public VM: any = {};

    public STEPIDS: any = {
      stepSearch: 1,
    };

    public currentOlsUser: any = {};
    public clientData: any = {};

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;
    public userName: string = ""

    public reportGroups: any = {};
    public months: any = [];

    public formSettings: any = {
      plateNoIsVisible: false,
      permitNoIsVisible: false,
      timePeriodType: "",
      timePeriod: 0,
      errorMessage: "",
      isError: false,
      yearIsVisible: false,
      dayIsVisible: false,
      isCarrier: false,
    }

    public loader: any = {
      loaded: false,
      loading: false,
      canRender: false
    };

    // Mobile funcions
    public isMobile: boolean = false;
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    }


    //created() {
    //  if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
    //    import('../../olsStateManagement/css/olsOverrideDev.scss')
    //  }
    //}

    mounted() {
      if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
        let userData = userService.getUser();
        userData
          .then((result) => {
            this.clientData = JSON.parse(JSON.stringify(result));
            this.loadData();
            this.isAuthorized = this.clientData.isLoggedIn;
          });
      } else {

        authService.getUser()
          .then((user: any) => {
            if (user) {
              this.emailVerified = authService.emailVerified();

              if (user.profile.email_verified) {
                this.isAuthorized = authService.isAuthorized();

                if (this.isAuthorized) {

                  this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                  let pOlsUser = sessionStorage.getItem('olsUser')
                  if (pOlsUser) {
                    let olsUser = JSON.parse(pOlsUser);

                    axios
                      .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true',)
                      .then(response => {
                        this.clientData = response.data;
                        this.loadData()
                      })
                      .catch(error => console.log(error))
                  }
                }
                else {
                  authService.logout();
                }
              }
              // else in store.js user is redirected to email-not-verified page!
            }
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
          })

      }
    }
    public loadData() {
      this.clearDocuments(true);
      this.selectedDocuments = {};
      this.loader.loading = true;
      axios
        .get('client/initdocumentsearch/' + this.clientData.olsUserId + '/' + this.clientData.clientId)
        .then(response => {
          this.VM = response.data;
          this.VM.documentType.noDataText = "No Document Types available"
          this.loader.canRenderHtml = this.VM.documentType != null;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.clearDocuments(false);
        });
    }
    //Documents
    //data
    public selectedDocuments: any = {};

    //getters
    get documentsHideDefaultFooter() {
      if (this.VM.documents) {
        return this.VM.documents.length < 10;
      }
      return false;
    }

    public somethingChanged() {
      GF.clearAlert(this.VM.stepSearch.alert);
    }

    public documentTypeChanged() {
      GF.clearAlert(this.VM.stepSearch.alert);

      let reportGroupId = this.VM.documentType.value;

      let selectedReportGroup = this.VM.documentType.items.filter((item: any) => item.id == reportGroupId);
      //console.log(selectedReportGroup);
      if (selectedReportGroup == null || selectedReportGroup.length == 0 || selectedReportGroup[0].rec == null) {
        this.formSettings.plateNoIsVisible = false;
        this.formSettings.permitNoIsVisible = false;
        this.formSettings.errorMessage = "";
        this.formSettings.isError = false;
        this.formSettings.yearIsVisible = false;
        this.formSettings.dayIsVisible = false;
        this.formSettings.timePeriodType = "";
        this.formSettings.timePeriod = 0;
        this.formSettings.isCarrier = false;
      }
      else {
        this.formSettings.plateNoIsVisible = selectedReportGroup[0].rec.plateNoIsVisible;
        this.formSettings.permitNoIsVisible = selectedReportGroup[0].rec.permitNoIsVisible;
        this.formSettings.errorMessage = selectedReportGroup[0].rec.errorMessage;
        this.formSettings.isError = selectedReportGroup[0].rec.isError;
        this.formSettings.yearIsVisible = selectedReportGroup[0].rec.yearIsVisible;
        this.formSettings.dayIsVisible = selectedReportGroup[0].rec.dayIsVisible;
        this.formSettings.timePeriodType = selectedReportGroup[0].rec.timePeriodType;
        this.formSettings.timePeriod = selectedReportGroup[0].rec.timePeriod;
        this.formSettings.isCarrier =  selectedReportGroup[0].rec.isCarrier;
      }

      var newId = 0;
      var newText = "";
      if (this.formSettings.yearIsVisible) {
        this.VM.year.items = [];

        if (selectedReportGroup[0].rec.timePeriod > 0) {
          for (let iY = 1; iY <= selectedReportGroup[0].rec.timePeriod; iY++) {
            newId = this.VM.currentYear - iY + 1;
            newText = "" + newId;
            this.VM.year.items.push({ id: newId, text: newText });
          }
        }
        this.VM.year.value = this.VM.currentYear;
      }

      if (this.formSettings.isError) {
        GF.setAlertError(this.VM.stepSearch.alert, this.formSettings.errorMessage);
      }
    }

    findDocuments() {
      let documentRequest = {
        reportGroupId: this.VM.documentType.value,
        clientId: this.clientData.clientId,
        timePeriodType: this.formSettings.timePeriodType,
        timePeriod: 0,
        month: 0,
        plateNumber: this.formSettings.plateNoIsVisible ? this.VM.plateNumber.value : '',
        permitNumber: this.formSettings.permitNoIsVisible ? this.VM.permitNumber.value : '',
        olsUserId: this.clientData.olsUserId
      }

      if (this.formSettings.yearIsVisible) {
        documentRequest.timePeriod = this.VM.year.value;
        documentRequest.month = this.VM.month.value;
      }
      if (this.formSettings.dayIsVisible) {
        documentRequest.timePeriod = this.formSettings.timePeriod;
      }

      //console.log(documentRequest);

      this.loader.loading = true;
      axios
        .post('client/getonlineservicesdocumentsforclient', documentRequest)
        .then(response => {
          // console.log(documentRequest);
          this.VM.stepSearch.alert = response.data.stepSearch.alert;
          this.VM.documents = response.data.documents;
          if (!Object.keys(response.data.documents).length) {
            GF.setAlertError(this.VM.stepSearch.alert, this.VM.wizardMessages.DocumentSearchNoneFound);
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }
    clearDocuments(isOnLoad: boolean) {
      if (!isOnLoad) {
        //this.VM.year.value = this;
        this.VM.month.value = 0;
        this.VM.plateNumber.value = "";
        this.VM.permitNumber.value = "";
        this.VM.documents = [];
        this.documentTypeChanged();
      }
    }

    getChargedActionId() {
      let selectedReportObj = this.VM.carrierReport.items.filter( (x: any) => x.id === this.VM.carrierReport.value)
      if (selectedReportObj){
        return selectedReportObj[0].rec.chargedActionId;
      }
      return 0;
    }

    addToCart() {

      let dr = {
          clientId: this.clientData.clientId,
          olsUserId: this.clientData.olsUserId,
          reportId: this.VM.carrierReport.value,
          chargeActionId: this.getChargedActionId()
        }

        axios
          .post('client/addDocumentToCart', dr)
          .then(response => {
            this.VM.documentError = response.data.documentError;
            if (!this.VM.documentError.hasAny) {
              //
            } else if (this.VM.documentError.hasSuccess) {
              //this.VM.currentStepId = this.STEPIDS.stepValidation;
            }
            this.VM.jumpToCart = response.data.jumpToCart;
          })
          .catch(error => console.log(error))
          .finally(() => {
            if (this.VM.jumpToCart) {
              this.redirectToFullURL(this.VM.shoppingCartWebAddress);
            }
          });
    }

    getDocumentsTableHeaders() {
      return [
        { text: '', value: 'download', sortable: false, width: 'auto' },
        { text: '', value: 'open', sortable: false, width: 'auto' },
        { text: this.VM.wizardLabels.Description, value: 'reportDescription', align: 'start', sortable: false, width: '650px' },
      ];
    }
    openPdf(printingQueueId: number, pdfFileId: number, fileName: any, justOpen: boolean) {
      if (printingQueueId == null) return;

      if (pdfFileId == null) pdfFileId = 0;
      this.loader.loading = true;

      axios('lookups/getpdf/' + printingQueueId + '/' + pdfFileId, { method: 'GET', responseType: 'blob' })
        .then(response => {
          //Create a Blob from the PDF Streamblobproperty
          var file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);

          if (justOpen) {
            //Open the URL on new Window
            window.open(fileURL);
          }
          else {
            const tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = fileURL;
            tempLink.setAttribute('download', fileName);
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);

            setTimeout(() => {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(fileURL);
            }, 100);
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
        });
    }

    get hasAnyDocuments() {
      if (!this.VM.documents) return false;
      return this.VM.documents.length > 0;
    }

    downloadAll() {
      for (var i = 0; i < this.VM.documents.length; i++) {
        this.openPdf(this.VM.documents[i].printingQueueId, this.VM.documents[i].pdfFileId, this.VM.documents[i].pdfFileName, false);
      }
    }

    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

    redirectToFullURL(url:string) {
      return window.location.href = url;
    }
  }
